import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnInit,
  inject,
} from '@angular/core';
import {
  BasicCustomerResponse,
  CustomerType,
  EmailListType,
  MarketingService,
} from 'api';
import { AbilityServiceSignal } from '@casl/angular';
import { PureAbility } from '@casl/ability';
import {
  AddressLineFormatPipe,
  CustomerNamePipe,
  NameCasePipe,
  NullFormatterPipe,
  PhonePipe,
  SortCustomerPhonesPipe,
  YesNoPipe,
  isCompany,
  isReseller,
} from 'common';
import { Observable, map } from 'rxjs';
import { AddressVerificationCheckComponent } from './address-verification-check/address-verification-check.component';

export const customerTypeToEmailListTypeMap: Record<
  CustomerType,
  EmailListType
> = {
  CONSUMER: 'GLOBAL',
  ORGANIZATION: 'GLOBAL',
  EMPLOYEE: 'GLOBAL',
  RESELLER: 'RESELLER',
};

@Component({
  selector: 'ss-stx-shared-customer-contact-info',
  imports: [
    CommonModule,
    SortCustomerPhonesPipe,
    PhonePipe,
    YesNoPipe,
    AddressLineFormatPipe,
    NameCasePipe,
    NullFormatterPipe,
    AddressVerificationCheckComponent,
    CustomerNamePipe,
  ],
  templateUrl: './customer-contact-info.component.html',
  styleUrls: ['./customer-contact-info.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CustomerContactInfoComponent implements OnInit {
  private ability =
    inject<AbilityServiceSignal<PureAbility>>(AbilityServiceSignal);
  private readonly marketingService = inject(MarketingService);

  @Input() customer!: BasicCustomerResponse;
  isCompanyOrReseller = false;
  emailList$?: Observable<boolean>;

  can(action: string, subject: string): boolean {
    return this.ability.can(action, subject);
  }

  ngOnInit(): void {
    if (this.customer.emailAddress) {
      this.emailList$ = this.marketingService
        .getMember(
          this.customer.emailAddress,
          customerTypeToEmailListTypeMap[this.customer.customerType]
        )
        .pipe(map((response) => response.subscribed));
    }

    this.isCompanyOrReseller =
      isCompany(this.customer) || isReseller(this.customer);
  }
}
